import { styled } from '@mui/material/styles'
import { Grid, Stack, Typography, MenuItem } from '@mui/material'

export const MainWrapper = styled(Grid)`
  width: 100vw;
  height: 100vh;
`

export const ImageWrapper = styled(Grid)`
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.palette.primary.main};
  background-image: linear-gradient(
    to top,
    rgba(20, 13, 64, 0.1) 30%,
    rgba(72, 97, 255, 0.4) 55%
  );
  overflow: hidden;

  @media (max-width: ${({ theme }) => theme.breakpoints.values.md}px) {
    display: none;
  }
`

export const ContentSectionWrapper = styled(Grid)`
  padding: 40px 32px 20px 32px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.values.lg}px) {
    padding: 32px 18px 20px 16px;

    & h6 {
      display: none;
    }
  }
`

export const HeadSectionWrapper = styled(Stack)`
  @media (max-width: ${({ theme }) => theme.breakpoints.values.lg}px) {
    padding: 0px 14px 0px 16px;
  }
`

export const ContentWrapper = styled(Stack)`
  padding: 50px 0px;
  position: relative;
  justify-content: space-around;
  min-height: calc(100vh - 130px);

  & div {
    align-items: center;

    & p {
      text-align: center;
    }
  }
`

export const Title = styled(Typography)`
  font-size: 20px;
  font-weight: 600;
`

export const MainHeading = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 36px;
`

export const CaptionText = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 18px;
  line-height: 27px;
`

export const FooterContent = styled(Typography)`
  text-align: center;
  font-size: 12px;
  line-height: 18px;
  color: ${({ theme }) => theme.palette.text.secondary};
`

export const LanguageMenuItem = styled(MenuItem)({
  minHeight: 'fit-content',
  display: 'flex',
  justifyContent: 'space-between',
})
